<script setup lang="ts">
import { ref, watch } from 'vue'
import dayjs from '@/lib/dayjs'

type Student = {
  id: number
  name: string
  last_name: string
  cabinet_url?: string
  login_token?: string
  [key: string]: unknown
}

const emit = defineEmits<{
  (event: 'open-login-modal', student: Student): void
}>()

const isOpen = ref(false)
const student = ref<Student | null>(null)
const courseName = ref('')
const purchaseExpiryDate = ref('')

watch(isOpen, value => {
  if (!value) student.value = null
})

function open(studentValue: Student, newCourseName: string, newPurchaseExpiryDate: string) {
  isOpen.value = true
  student.value = studentValue
  courseName.value = newCourseName
  purchaseExpiryDate.value = newPurchaseExpiryDate
}

defineExpose({
  $open: open
})

function formatDate(date: string) {
  return dayjs(date).format('D MMMM YYYY')
}

function openLoginModal() {
  if (!student.value) return
  emit('open-login-modal', student.value)
  isOpen.value = false
}
</script>

<template>
  <v-modal v-model="isOpen">
    <div v-if="student" class="parent-onboarding-modal">
      <div class="parent-onboarding-modal__heading">
        <v-icon size="48">success</v-icon>
        Умный Учебник {{ courseName }} получен
      </div>

      <p class="mt-3">
        Учебник доступен в кабинете ученика <b>{{ student.last_name }} {{ student.name }}</b> до <b>{{
          formatDate(purchaseExpiryDate)
        }}</b
        >.
      </p>

      <p class="mt-2">
        Вы можете открыть кабинет ученика на сайте МирГоворит через браузер или войти с другого устройства по QR-коду.
      </p>

      <v-button mode="large warn block" class="mt-4" :href="student.cabinet_url">
        <v-icon class="mr-1">mdi-open-in-new</v-icon>
        Кабинет ученика
      </v-button>

      <v-button mode="large primary block" class="mt-2" @click="openLoginModal">
        <v-icon class="mr-1">mdi-cellphone</v-icon>
        Войти с другого устройства
      </v-button>
    </div>
  </v-modal>
</template>

<style lang="scss">
.parent-onboarding-modal {
  @include desktop {
    max-width: 500px;
  }

  &__heading {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    @include text-h3;
  }

  b {
    white-space: nowrap;
  }
}
</style>
